export { default } from "./HelpPage";

